module.exports = __webpack_public_path__ + "img/japanese-character-chart-design-Tashii-Designs.96103956.jpg";